var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"new-field-button"},[_c('BaseIcon',{staticClass:"new-field-button__ico-plus",attrs:{"name":"circle-plus"}}),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),(_vm.titleStrong)?_c('strong',[_vm._v("\n        "+_vm._s(_vm.titleStrong)+"\n      ")]):_vm._e()])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640627b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewFieldButton.vue
// module id = 600
// module chunks = 0